
import Select from "react-select";



const FilterSelect = ({options, value, isMulti=false, placeholder, isLoading, optionLabel, optionValue, onChange, isClearable, className, isDisabled=false, defaultValue, menuPlacement="auto", noOptionsLabel="employees"}) => {

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 40,
      fontSize:12
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }), /* Ensures visibility */
    menuList: (base) => ({
      ...base,
      maxHeight: "300px", // Limit menu height for better performance
      overflowY: "auto", // Enable vertical scrolling
      overflowX: "hidden"
    }),
    option: (provided, state) => ({
      
      ...provided,
      backgroundColor: state.isFocused ? "#D3001A" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#D3001A",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      flexWrap: "nowrap", // Prevent wrapping
      overflowX: "auto", // Enable horizontal scrolling
      whiteSpace: "nowrap",
      maxWidth: "100%"
    }),
  };


  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     display: "flex",
  //     overflow: "hidden"
  //   }),
  //   valueContainer: (provided) => ({
  //     ...provided,
  //     display: "flex",
  //     flexWrap: "nowrap", // Prevent wrapping
  //     overflowX: "auto", // Enable horizontal scrolling
  //     whiteSpace: "nowrap",
  //     maxWidth: "100%"
  //   }),
  //   multiValue: (provided) => ({
  //     ...provided,
  //     marginRight: "4px" // Space between selected items
  //   })
  // };

  
  return (

          <div className=" form-focus select-focus">
            <Select 
            defaultValue={defaultValue}
            isDisabled={isDisabled}
            isClearable={isClearable}
            isSearchable={true}
            onChange={onChange}
                getOptionLabel={option => option[optionLabel]}
                getOptionValue={option => option[optionValue]}
              isLoading={isLoading}
              menuPlacement={menuPlacement}
              options={options}
              placeholder={placeholder}
              styles={customStyles}
              value={value}
              isMulti={isMulti}
              className={className}
              menuPortalTarget={document.body} /* Fix dropdown being hidden */
              filterOption={(option, inputValue) => {
                // Custom filter function for better search performance
                if (!inputValue) return true;
                const label = option.data[optionLabel]?.toLowerCase() || '';
                return label.includes(inputValue.toLowerCase());
              }}
              noOptionsMessage={({ inputValue }) => 
                inputValue ? `No ${noOptionsLabel} found matching "${inputValue}"` : `No ${noOptionsLabel} available`
              }
            />
            {/* <label className="focus-label">Designation</label> */}
          </div>
       
  );
};

export default FilterSelect;
